import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { TRANSACTIONS } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const transactionsReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return reducers.dataTable.tableFetchReducer(TRANSACTIONS, state, action)
  }
}

const transactionsDownloadReducer = (state = initialState, action) =>
  reducers.dataTable.downloadFetchReducer(TRANSACTIONS, state, action)

export default combineReducers({
  data: transactionsReducer,
  tableInfo: tableReducer,
  downloadData: transactionsDownloadReducer,
})

export { initialState, transactionsReducer }
